import { Card, Popover } from 'antd';
import { PaperClipOutlined } from '@ant-design/icons';
import { Hint, LateBloomerTag, BoxedSetTag, RisingStar } from '../../components/Tags';

const { Meta } = Card;

const OverlayHeader = ({ book, zoomedCoverImage, handleCopyUrl, Dot }) => (
  <Card className='overlay-card'>
    <Meta
      className='overlay-meta'
      avatar={
        <Popover content={zoomedCoverImage} placement='leftBottom' trigger={'hover'}>
          <img src={book['largecoverimageurl']} alt='' className='overlay-img' />
        </Popover>
      }
      title={
        <div className='overlay-text-wrap'>
          <div className='overlay-author-container'>
            <div className='overlay-author'>
              {Boolean(book['CRM Author Id']) && (
                <Popover content={<p>Author Sent To Hubspot</p>}>
                  <Dot color={'rgba(158,255,201,0.42)'} />
                </Popover>
              )}
              {book['Author']}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <div className='header-notification'>
                <PaperClipOutlined
                  data-testid='copy-btn'
                  className='copy-icon'
                  onClick={handleCopyUrl}
                />
              </div>
            </div>
          </div>

          <div className='overlay-title-wrap'>
            {book['Title']}
            <div>
              {book['series_has_audio'] && (
                <Hint hint='A title in this series has audio' color={'#00B27B'} />
              )}
              {Boolean(book['late_bloomer']) && (
                <LateBloomerTag hint='Late Bloomer' color={'red'} />
              )}
              {Boolean(book['is_boxset']) && (
                <BoxedSetTag hint='This title is a boxed set' />
              )}
              {Boolean(book['is_risingstar']) && (
                <RisingStar hint='This title has been a Rising Star' color={'#F6BE00'} />
              )}
            </div>
          </div>
        </div>
      }
      description={<div className='overlay-description-wrap'>{book['Series']}</div>}
    />
  </Card>
);

export default OverlayHeader;